module.exports = __webpack_public_path__ + "img/jfbg.36dee272.png";